import * as React from 'react';
import Button from '../button';
export default function PickerButton(props) {
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    size: "small",
    type: "primary"
  }, props));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/date-picker/PickerButton.js
// module id = 1674
// module chunks = 0